import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgGridView({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 15a3 3 0 110 6h-3a3 3 0 110-6h3zM6.5 11a3.5 3.5 0 013.5 3.5v3a3.5 3.5 0 11-7 0v-3A3.5 3.5 0 016.5 11zM18 17h-3a1 1 0 100 2h3a1 1 0 000-2zM6.5 13A1.5 1.5 0 005 14.5v3a1.5 1.5 0 003 0v-3A1.5 1.5 0 006.5 13zm11-10A3.5 3.5 0 0121 6.5v3a3.5 3.5 0 01-7 0v-3A3.5 3.5 0 0117.5 3zm0 2A1.5 1.5 0 0016 6.5v3a1.5 1.5 0 003 0v-3A1.5 1.5 0 0017.5 5zM9 3a3 3 0 110 6H6a3 3 0 010-6h3zm0 2H6a1 1 0 000 2h3a1 1 0 100-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgGridView
